const phoneMask = (phoneNumber:any) => {
    let maskedNumber = phoneNumber;
    // Remove all non-digit characters from phone number
    if (phoneNumber) {
        const formattedNumber = phoneNumber.replace(/\D/g, "");
     
        // // Format the phone number using regular expression groups
        maskedNumber = formattedNumber.replace(/^(\d{3})(\d{3})(\d{4})$/, "$1-$2-$3");
     } else {
        maskedNumber = phoneNumber;
     }
     
     return maskedNumber;
};

export default phoneMask;